import { MODE } from "@lhd/types";
import { ROUTES } from "./routes.constant";

export * from "./messages.constant";
export * from "./routes.constant";
export * from "./services.constant";
// export * from "./worker.constant";
export * from "./messages.constant";
export * from "./tax.constant";
export * from "./worker.constant";
export * from "./colors";
export * from "./cloneApp.constant";
export const DATE_TIME_FORMAT = {
  /* ===== Date & Time ===== */
  DATE_TIME: "YYYY/MM/DD HH:mm",
  DATE_TIME_DASH: "YYYY-MM-DD HH:mm",
  DATE_TIME_SLASH: "DD/MM/YYYY HH:mm",
  DATE_TIME_DASH_SEC: "YYYY-MM-DD HH:mm:ss",
  DATE_TIME_SLASH_SEC: "DD/MM/YYYY HH:mm:ss",
  DATE_TIME_CLOSE_BRACKET: "YYYY年MM月DD日_HH_mm_ss",
  /* ===== Date ===== */
  DATE_DEFAULT: "YYYY/MM/DD",

  // Japan formx
  MONTH_JP: "MM月度",
  DATE_DASH: "YYYY-MM-DD",
  DATE_SLASH_DMY: "DD/MM/YYYY",
  DATE_DOT: "DD.MM.YYYY",
  DATE: "YYYY/MM/DD (ddd)",

  /* ===== Japan (zero-padding) ===== */
  DATE_JP: "YYYY年MM月DD日", // 2025年12月01日
  DATE_JP_WEEK: "YYYY年MM月DD日(ddd)",
  DATE_TIME_JP: "YYYY年MM月DD日HH:mm",
  DATE_JP_TIME: "YYYY年MM月DD日 HH:mm",
  DATE_MONTH_JP: "YYYY年MM月",

  /* ===== Japan (NO zero-padding) ⭐️ NEW ===== */
  DATE_JP_MD: "YYYY年M月D日", // 2025年12月1日
  DATE_JP_MD_WEEK: "YYYY年M月D日(ddd)",
  DATE_TIME_JP_MD: "YYYY年M月D日HH:mm",
  DATE_JP_MD_TIME: "YYYY年M月D日 HH:mm",
  DATE_MONTH_JP_M: "YYYY年M月",

  /* ===== Japan others ===== */
  DATE_JP_SLASH: "YYYY/MM/DD",
  DATE_JP_DOT: "YYYY.MM.DD",
  YEAR_JP: "YYYY年",
  WEEK_JP: "YYYY年WW週",

  // NEW: Japanese full formats with weekday
  DATE_JP_WITH_DAY: "YYYY年MM月DD日(dd)", // 2025年06月15日(日)
  DATE_JP_WITH_DAY_LONG: "YYYY年MM月DD日(dddd)", // 2025年06月15日(日曜日)
  DATE_JP_SHORT: "YYYY年M月D日(dd)", // 2025年6月15日(日)
  DATE_JP_FULL: "YYYY年M月D日(ddd) HH:mm", // 2025年6月15日(日) 14:30
  DATE_JP_MD_DAY: "M月D日(dd)",
  DATE_JP_DAY: "D日 （ddd）",
  MONTH_YEAR_JP: "YYYY年MM月",

  /* ===== ISO / API ===== */
  DATE_QUERY: "YYYY-MM-DD",
  DATE_TIME_INPUT: "YYYY-MM-DDTHH:mm",
  ISO_DATE: "YYYY-MM-DDTHH:mm:ss",
  ISO_DATE_Z: "YYYY-MM-DDTHH:mm:ssZ",
  ISO_DATE_MILLI: "YYYY-MM-DDTHH:mm:ss.SSSZ",

  /* ===== Time ===== */
  TIME: "HH:mm",
  TIME_H: "H:mm",
  /* ===== Year / Month ===== */
  YEAR_MONTH: "YYYY/MM",
  MONTH: "MM",
  YEAR: "YYYY",
};

export const REGEX = {
  // PASSWORD:
  //   /^(?=.*[A-Z])[a-zA-Z\d@$!%*#?&_._~_,_;_:_'_"_<_>_/_?_+_=_^_(_)_[_{_}_|_\]_\\_`_-]{6,20}$/,
  PASSWORD: /^(?=.*[a-z])(?=.*[A-Z]).{6,20}$/,
  NUMBER: /\D+/g,
  URL: /(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_+.~#?&//=]*)/g,
  ZIP_CODE: /^\d{7}$|^\d{3}-\d{4}$/,
  PHONE_NUMBER: /^[0-9０-９+\-＋－ \u3000]*$/,
  EMAIL: /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@(?:[a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}$/,
  PHONE_NUMBER_WITH_MIN_LENGTH: /^[0-9０-９+\-＋－ \u3000]{10,}$/,
};

export const COLUMN_TYPE_SETTING = [
  { type: "text", value: "text" },
  { type: "checkbox", value: "checked" },
  { type: "number", value: "value" },
  { type: "dropdown", value: "selectedValue" },
  { type: "date", value: "date" },
  { type: "time", value: "time" },
  { type: "email", value: "text" },
  { type: "numberCurrency", value: "text" },
  { type: "dateTimeCustom", value: "text" },
  { type: "monthPicker", value: "date" },
  { type: "zipCodeCellCustom", value: "text" },
  { type: "password", value: "text" },
  { type: "numberformat", value: "value" },
];

export const PERMISSIONS = {
  human_resource_management: "human_resource_management",
  labor_management: "labor_management",
  company_management: "company_management",
  operational_management: "operational_management",
  full_permission: "full_permission",
  create: "create",
  edit: "edit",
  view: "view",
  delete: "delete",
};

export const QUERY_NAME = {
  WORKER_BREADCRUMB_INFO: "worker_breadcrumb_info",
  APPS: "apps",
  APP_PARTS: "app_parts",
  APP: "app",
  APPRAISALS: "appraisals",
  APPRAISAL: "appraisal",
  APPRAISAL_SETTINGS: "appraisal_settings",
  APPRAISAL_SETTING: "appraisal_setting",
  APPRAISAL_SHEETS: "appraisal_sheets",
  APPRAISAL_SHEETS_DETAILS: "appraisal_sheets_details",
  APPRAISAL_SHEETS_DETAIL_FEEDBACKS: "appraisal_sheets_detail_feedbacks",
  APPRAISAL_SHEETS_UNSEEN: "appraisal_sheets_unseen",
  APPRAISAL_SHEET: "appraisal_sheet",
  APP_PERMISSIONS: "app_permissions",
  APPS_WITH_PERMISSIONS: "apps_with_permissions",
  APP_PERMISSIONS_CURRENT_USER: "app_permissions_current_user",
  APP_PERMISSIONS_LIST_POSITIONS: "app_permissions_list-postions",
  APP_PERMISSIONS_LIST_WORKERS: "app_permissions_list-workers",
  APP_PERMISSIONS_LIST_ORGS: "app_permissions_list_orgs",
  APP_PERMISSIONS_APPRAISAL: "app_permissions_appraisal",
  CATEGORY_STATUSES: "category_statuses",
  CATEGORY_STATUS: "category_status",
  CATEGORY_STATUS_COMPANIES: "category_status_companies",
  CATEGORY_STATUS_COMPANY: "category_status_company",
  CATEGORY_STATUS_WORKER_SETTINGS: "category_status_worker_settings",
  CATEGORY_STATUS_USER_SETTINGS: "category_status_user_settings",
  PREFECTURES: "prefectures",
  ORGANIZATIONS: "organizations",
  ORGS: "orgs",
  ORGS_CHART: "orgs_chart",
  ALL_ORG_FOR_CHART: "all_org_chart",
  ORG: "org",
  ORGS_AND_NODES: "orgs_and_nodes",
  DEPARTMENTS: "departments",
  BRANCHES: "branches",
  DIVISIONS: "divisions",
  CURRENT_USER: "current_user",
  WORKERS: "workers",
  EMERGENCY_ADDRESS: "emergency-address",
  WORKER: "worker",
  USERS: "users",
  USER: "user",
  ME: "me",
  COMPANY: "company",
  COMPANIES: "companies",
  ACCOUNT_TITLE: "account_title",
  PROVISION_ITEM: "provision_item",
  PROVISION_TYPE: "provision_type",
  EXPENSE_TYPE: "expense_type",
  ARRANGEMENT_TYPE: "arrangement_type",
  ALLOWANCE_TYPE: "allowance_type",
  TRANSFERS: "transfers",
  PROVISIONS: "provisions",
  POSITIONS: "positions",
  POSITION: "position",
  EXPENSES: "expenses",
  WORKS: "works",
  ARRANGEMENTS: "arrangements",
  DEDUCTIONS: "deductions",
  STAFF_TAX_SHEETS: "staff_tax_sheets",
  FETCH_RECORD: "fetch_record",
  CLIENTS: "clients",
  CLIENT: "client",
  PROJECTS: "projects",
  PROJECT: "project",
  TASKS: "tasks",
  TASK: "task",
  CONFIGS: "configs",
  EVENTS: "events",
  ORG_NODES: "org_nodes",
  TABLE_META_CONFIGS: "table_meta_configs",
  APP_CATEGORIES: "app_categories",
  APP_CATEGORY: "app_category",
  GROUP_PERMISSIONS_SETTING: "group_permissions_setting",
  ANNUAL_SUMMERIES: "annual_summeries",
  SALARY_PERMISSIONS: "salary_permissions",
  KPI: "kpi",
  KPI_TREE: "tree",
  KPI_CATEGORIES: "categories",
  KPI_CLASSIFICATION: "kpi_classifications",
  LESSON_DETAIL: "lesson_detail",
  LESSON_LIST: "lesson_list",
  E_LEARNING_COURSE_LIST: "e_learning_course_list",
  E_LEARNING_COURSE_ON_STORE_LIST: "e_learning_course_on_store_list",
  COURSE_HISTORIES: "course_histories",
  UPLOAD_MULTIPLE_MEDIA: "multiples_file",
  UPLOAD_SINGLE_MEDIA: "single_file",
  COURSE_VIEWERS: "course_viewers",
  CONFIG_TAX: "config_tax",
  CUSTOM_FILTER_CONFIGS: "custom_filter_configs",
  E_LEARNING_PERMISSIONS: "e_learning_permissions",
  E_LEARNING_DEFAULT_PERMISSIONS: "e_learning_default_permissions",
  E_LEARNING_COURSES_WITH_PERMISSIONS: "e_learning_courses_with_permissions",
  E_LEARNING_CURRENT_USER_PERMISSIONS: "e_learning_current_user_permissions",
  MAINTENANCE_NOTICES: "maintenance_notices",
  //for app record permission
  APP_RECORD_PERMISSIONS: "app_record_permissions",
  LIST_LESS_FIELDS: "/list_less_fields",
  INVOICE_LIST: "invoice_list",
  BANK_INFOS: "company_bank_infos",
  COMPANY_LEADERSHIPS: "company_leaderships",
  COMPANY_ACCOUNTING_PERIODS: "company_accounting_periods",
  COMPANY_TAX_HISTORIES: "company_tax_histories",
  COMPANY_NAMES: "company_names",
  COMPANY_FINANCIAL_STATEMENTS: "company_financial_statements",
  COMPANY_REGULATIONS: "company_regulations",
  COMPANY_LOCATIONS: "company_locations",
  COMPANY_REGISTRATION_INFOS: "company_registration_infos",
  COMPANY_PHONE_NUMBERS: "company_phone_numbers",
  WORKER_LOGIN_INFO: "user_accounts",
  WORKER_EMERGENCY_CONTACT: "worker_emergency_contacts",
  WORKER_STORE_NAMES: "worker_stores",
  WORKER_PHONE_NUMBERS: "worker_phone_numbers",
  WORKER_GENDER: "worker_gender",
  WORKER_CURRENT_ADDRESS: "worker_current_address",
  WORKER_EMERGENCY_ADDRESS: "worker_emergency_addresses",
  WORKER_NAME_HISTORY: "worker_names",
  WORKER_ONBOARDING: "worker_onboardings",
  WORKER_INSURANCE: "worker_insurances",
  WORKER_ASSIGNMENT: "worker_assignments",
  WORKER_DEVICE: "worker_devices",
  WORKER_BASE_SALARY: "worker_base_salaries",
  WORKER_BANK_INFOS: "worker_bank_infos",
  WORKER_COMPANY_EMAIL: "worker_company_emails",
  WORKER_EMAILS: "user_worker_emails",
  WORKER_PASSWORD: "current/password",
  WORKER_DEPENDANT_NAMES: "worker_dependant_names",
  WORKER_DEPENDANT_RELATIONSHIPS: "worker_dependant_relationships",
  COMPANY_PERMISSIONS: "company_permissions",
  WORKER_PERMISSIONS: "worker_permissions",
  COMPANY_WORKER_PERMISSIONS: "company_worker_permissions",
  COMPANY_PERMISSION_WITH_USER: "company_permission_with_user",
  WORKERS_IN_WORKER_PERMISSIONS: "workers_in_worker_permissions",
  POSITION_IN_COMPANY_PERMISSIONS: "position_in_company_permissions",
  ORG_IN_COMPANY_PERMISSIONS: "org_in_company_permissions",
  WORKER_PERMISSION_FOR_CURRENT_USER: "worker_permission_for_current_user",
  USER_INTERFACE_SETTINGS: "user_interface_settings",
  WORKER_LOGTIMES: "worker_logtimes",
  LOGTIME_PERMISSIONS: "logtime_permissions",
  APPLICATIONS: "applications",
  PAYMENT_HISTORY: "payment_history",
  CLIENT_NAMES: "client_names",
  CLIENT_PHONE_NUMBERS: "client_phone_numbers",
  CLIENT_INVOICES: "client_invoices",
  CLIENT_BANK_INFOS: "client_bank_infos",
  CLIENT_LEADERSHIPS: "client_leaderships",
  CLIENT_ACCOUNTING_PERIODS: "client_accounting_periods",
  CLIENT_REGISTRATION_INFOS: "client_registration_infos",
  CLIENT_TAX_HISTORIES: "client_tax_histories",
  CLIENT_LOCATIONS: "client_locations",
  CLIENT_CONTRACT_STATUSES: "client_contract_statuses",
  CLIENT_CONTRACT_TYPES: "client_contract_types",
  BIZ_PROJECT: "biz_project_manager",
  BIZ_PROJECT_TASK: "biz_project_manager_task",
  BIZ_PROJECT_ASSIGNEES: "biz_project_assignees",
  QUOTATION_PROVIDERS: "quotation_providers",
  SETTING_MEMBERS: "setting_members",
  SETTING_MEMBERS_OWNER_AND_ADMIN_WORKERS:
    "setting_members_owner_and_admin_workers",
  REPORT_FORM: "report_form",
  CURRENT_USER_PERMISSIONS: "current_user_permissions",
  CHECK_INVITE_NOTIFICATION: "check_invite_notification",
  WORKER_SHARE_SETTINGS: "worker_share_settings",
  WORKER_SETTING_INVATIONS: "worker_setting_invitations",
  WORKER_NOTI_REJECT_INVITATIONS: "worker_noti_reject_invitations",
  WORKER_NOTI_CANCELLED_INVITATIONS: "worker_noti_cancelled_invitations",
  COMPANY_INVESTOR_HISTORIES: "company_investor_histories",
  COMMENTS: "comments",
  COMPANY_POLICY_PERMISSIONS: "company_policy_permissions",
  ROLE_PERMISSIONS: "role_permissions",
  HISTORY_FILTER_OPTIONS: "history_filter_options",
  COMPANY_PHONE_NUMBERS_OPTIONS: "company_phone_numbers_options",
  EMPLOYEE_INFO_CHILDREN_SELECTION: "employee_info_children_selection",
  INTERNAL_CONTROL_RECORD_PERMISSIONS: "internal_control_permission_records",
};

export const THUMBNAIL_SIZE_LIST = [
  {
    value: "50x50",
    label: "50x50",
  },
  {
    value: "150x150",
    label: "150x150",
  },
  {
    value: "250x250",
    label: "250x250",
  },
  {
    value: "500x500",
    label: "500x500",
  },
];

export const LAYOUT = {
  HORIZONTAL: "horizontal",
  VERTICAL: "vertical",
};

export const LAYOUT_LIST = [
  {
    value: "horizontal",
    label: "横",
  },
  {
    value: "vertical",
    label: "縦",
  },
];
export const SCHEDULER_COLORS = [
  "#195192",
  "#4950F1",
  "#D83232",
  "#E3A900",
  "#002A5B",
  "#FF6231",
  "#32CED8",
  "#009F08",
  "#754D4D",
  "#FE3571",
  "#B7B7B7",
];
export const PER_PAGE_DEFAULT = 1000000;

export const ORG_ID = "org_id";

export const ORG_NODE_ID = "org_node_id";

export const IMAGE_FILE_EXTENSIONS = [
  "jpg",
  "jpeg",
  "png",
  "gif",
  "bmp",
  "webp",
  "svg",
  "tiff",
];

export const VIDEO_FILE_EXTENSIONS = [
  "mp4",
  "webm",
  "mkv",
  "mov",
  "avi",
  "flv",
  "mpeg",
  "ogv",
  "mts",
  "m2ts",
  "mxf",
  "3gp",
  "webm",
];

// Combined array of all supported audio file extensions
export const AUDIO_EXTENSIONS = [
  "mp3",
  "aac",
  "m4a",
  "ogg",
  "wma",
  "flac",
  "alac",
  "wav",
  "aiff",
  "opus",
  "amr",
  "ra",
  "rm",
  "dsd",
];

export const EXCEL_EXTENSIONS = [
  // Modern Excel formats (Office 2007+)
  "xlsx", // Excel Workbook
  "xlsm", // Excel Macro-Enabled Workbook
  "xltx", // Excel Template
  "xltm", // Excel Macro-Enabled Template
  "xlsb", // Excel Binary Workbook

  // Legacy Excel formats (Office 97–2003)
  "xls", // Excel Workbook (legacy)
  "xlt", // Excel Template (legacy)
  "xlm", // Excel Macro (legacy)
  "xlw", // Excel Workspace

  "csv", //csv
];

export const WORD_EXTENSIONS = ["doc", "docx", "dot", "dotx", "docm", "dotm"];

export const PDF_EXTENSION = "pdf";
export const TXT_EXTENSION = "txt";

export const OFFICE_FILE_EXTENSIONS: string[] = [
  ...EXCEL_EXTENSIONS, // Excel
  ...WORD_EXTENSIONS, //word

  TXT_EXTENSION, //txt
  PDF_EXTENSION, //pdf
];

export const FILE_EXTENSIONS_CAN_PREVIEW: string[] = [
  ...IMAGE_FILE_EXTENSIONS,
  ...VIDEO_FILE_EXTENSIONS,
  ...OFFICE_FILE_EXTENSIONS,
  ...AUDIO_EXTENSIONS,
];

export function getFileNameFromURL(url: string) {
  const path = decodeURI(url).split("/"); // Split the URL by '/'
  const fileNameWithExtension = path[path.length - 1]; // Get the last element of the path
  const fileName = fileNameWithExtension.split("?")[0]; // Remove query parameters, if any
  return fileName;
}

export const Status = {
  UnSave: "UnSave",
  OpenModal: "OpenModal",
};
export const RELEASE_VERSION = "0.261030";

export const StatusAppStore = {
  new: "new",
  waitingForApprove: "waiting_for_approve",
  approved: "approved",
};

export const CopyTypeAppStore = {
  canEdit: "can_edit",
  syncConfigFromOriginal: "sync_config_from_original",
};

export const CUSTOMER_STATUS = {
  contracting: "取引中",
  active: "契約中",
  closed: "終了",
  suspended: "休止中",
};

export const CUSTOMER_CATEGORY = {
  customer: "顧客先",
  supplier: "仕入先",
  outsourcer: "外注先",
  referrer: "紹介者",
  others: "他追加",
};

export const APP_PERMISSION_TYPES = {
  add_new_app: "add_new_app" as const,
  general_app_read: "general_app_read" as const,
  general_app_edit: "general_app_edit" as const,
  general_app_delete: "general_app_delete" as const,
  general_app_default_value: "general_app_default_value" as const,
  specified_app_read: "specified_app_read" as const,
  specified_app_edit: "specified_app_edit" as const,
  specified_app_delete: "specified_app_delete" as const,
  add_new_record: "add_new_record" as const,
  general_record_read: "general_record_read" as const,
  general_record_edit: "general_record_edit" as const,
  general_record_delete: "general_record_delete" as const,
  specified_record_read: "specified_record_read" as const,
  add_new_app_part: "add_new_app_part" as const,
  specified_app_part_read: "specified_app_part_read" as const,
  specified_app_part_edit: "specified_app_part_edit" as const,
  specified_app_part_delete: "specified_app_part_delete" as const,
  salary_nodes: "salary_nodes" as const,
  salary_view: "salary_view" as const,
  salary_edit: "salary_edit" as const,
  salary_delete: "salary_delete" as const,
  salary_approve: "salary_approve" as const,
  logtime_nodes: "logtime_nodes" as const,
  logtime_view: "logtime_view" as const,
  logtime_edit: "logtime_edit" as const,
};

export const WORKER_LOGTIME_TARGET_TAB = "worker_logtime";

export const LOGTIME_APP_PERMISSION_TARGET = WORKER_LOGTIME_TARGET_TAB;

export const SETTING_CATEGORY_FROM = {
  WORKER_CREATE: "worker_create",
  WORKER_LIST: "worker_list",
  STAFF_TAX_SHEET: "staff_tax_sheet",
  PROVISIONS: "provisions",
  DEDUCTIONS: "deductions",
  WORKS: "works",
  EXPENSES: "expenses",
  BUSINESS_TRIP_REPORTS: "business_trip_reports",
  TRANSFER: "transfer",
  ARRANGEMENTS: "arrangements",
  SALARY_SHEETS: "salary_sheets",
  PAYMENT_SHEETS: "payment_sheets",
  PROJECT_MANAGER: "project_manager",
  LIST_MESS: "list_mess",
  BUSINESS_FLOWCHARTS: "business_flowcharts",
  BUSINESS_MANUALS: "business_manuals",
  COMPANY_POLICIES: "company_policies",
  CLIENT: "client",
};
export const COURSE_PERMISSION_TYPES = {
  add_new_course: "add_new_course",
  general_course_read: "general_course_read",
  general_course_edit: "general_course_edit",
  general_course_delete: "general_course_delete",
  default_course_read: "default_course_read",
  default_course_edit: "default_course_edit",
  default_course_delete: "default_course_delete",
  specified_course_read: "specified_course_read",
  specified_course_edit: "specified_course_edit",
  specified_course_delete: "specified_course_delete",
};
export const RECORD_PERMISSION_TYPES = {
  add_new_record: "add_new_record",
  general_record_read: "general_record_read",
  general_record_edit: "general_record_edit",
  general_record_delete: "general_record_delete",
  default_record_read: "default_record_read",
  default_record_edit: "default_record_edit",
  default_record_delete: "default_record_delete",
  specified_record_read: "specified_record_read",
  specified_record_edit: "specified_record_edit",
  specified_record_delete: "specified_record_delete",
};
export const PAGE_PATHS = [
  `/${ROUTES.ANNUAL_SALARY_SUMMARIES}/${ROUTES.ANNUAL_SALARY_LIST}`,
  `/${ROUTES.ANNUAL_SALARY_SUMMARIES}/${ROUTES.ANNUAL_PAYMENT_LIST}`,
  `/${ROUTES.Electronic_Learning}`,
  `/${ROUTES.Electronic_Learning}/${ROUTES.STORE}`,
  `/${ROUTES.CUSTOMER_LIST}`,
  `/${ROUTES.CUSTOMER_LIST}/${ROUTES.CREATE}`,
  `/${ROUTES.PROJECT_MANAGE}/${ROUTES.PROJECT_LIST}`,
  `/${ROUTES.APPRAISAL_LIST}`,
  `/${ROUTES.APPRAISAL_SHEET_LIST}`,
  `/${ROUTES.WORKERS}`,
  `/${ROUTES.WORKERS}/${ROUTES.WORKER_SHEETS}`,
  `/${ROUTES.POSITIONS}`,
  `/${ROUTES.ORGANIZATION_MANAGEMENT}`,
  `/${ROUTES.COMPANIES}`,
  `/${ROUTES.COMPANIES}/${ROUTES.CREATE}`,
  `/${ROUTES.APP_CATEGORIES}`,
  `/${ROUTES.MAINTENANCE_NOTIFICATION}`,
  `/${ROUTES.WORKERS_CREATE}`,
  `/${ROUTES.ORGANIZATION_CHART}`,
  `/${ROUTES.MAINTENANCE_NOTIFICATION}`,
  `/${ROUTES.LIST_MESS}`,
  `/${ROUTES.PROJECT_MANAGER}`,
  `${ROUTES.TRACKING_TIME}${ROUTES.LIST}`,
  `/${ROUTES.CONTRACT_STAFF_LIST}`,
];

export const OPTIONS_SETTING_SIZES = [
  { label: "大", value: "large" },
  { label: "中", value: "medium" },
  { label: "小", value: "small" },
];

export const FONT_SIZE = {
  small: "14px",
  medium: "17px",
  large: "20px",
};
export const FONT_SIZE_VALUE = {
  small: 15,
  medium: 17,
  large: 20,
};

export const CHECKBOX_SIZE = {
  small: 15,
  medium: 17,
  large: 20,
};

export const ROW_HEIGHT = {
  small: 20.5,
  medium: 30.5,
  large: 42.5,
};

export const ROW_HEIGHT_E_LEARNING = {
  small: 24.7,
  medium: 36.5,
  large: 51.5,
};

export const ROW_HEIGHT_APP_LIST_RECORD = {
  small: 24.7,
  medium: 36.5,
  large: 51,
};

export const ROW_HEIGHT_APP_LIST = {
  small: 26,
  medium: 38,
  large: 52.5,
};

export const ROW_HEIGHT_APPRAISAL_SHEETS = {
  small: 24.3,
  medium: 36,
  large: 51,
};

export const ROW_HEIGHT_ORG_CHART = {
  small: 27,
  medium: 33,
  large: 40,
};

export const FLOATING_FILTER_HEIGHT_ORG_CHART = {
  small: 27,
  medium: 33,
  large: 40,
};

export const PANEL_WIDTH_ORG_CHART = {
  small: 590,
  medium: 600,
  large: 716,
};

export const BUTTON_HEIGHT_ORG_CHART = {
  small: 22,
  medium: 28,
  large: 35,
};

export const BUTTON_HEIGHT_ORG_CHART_ACTIONS = {
  small: 19,
  medium: 24,
  large: 30,
};

export const SCALE_BY_DISPLAY_SIZE = {
  small: 1.2,
  medium: 1.5,
  large: 1.7,
};

export const BUTTON_HEIGHT = {
  small: 19,
  medium: 25,
  large: 32,
};
export const BUTTON_HEIGHT_LARGE = {
  small: 24,
  medium: 30,
  large: 37,
};

export const BUTTON_HEIGHT_QUICK_VIEW = {
  small: 22,
  medium: 25,
  large: 32,
};

export const HEIGHT_SELECTION_INPUT = {
  small: 19,
  medium: 24,
  large: 30,
};

export type DisplaySize = keyof typeof ROW_HEIGHT;

export interface TEXT_SCALE_PROPS {
  text_scale?: "small" | "medium" | "large";
  height?: number | string;
  isWorkerCreate?: boolean;
  displaySize?: "small" | "medium" | "large";
  showScrollBar?: boolean;
}

export const ONE_MB = 1024 * 1024;
export const LIMIT_UPLOAD_ATTACHMENT = 10;
export const LIMIT_UPLOAD_20_ATTACHMENT = 20;

export const ACTIVE_COLOR = "#1890ff";
export const INACTIVE_COLOR = "#aac8f3";
export const DISABLE_COLOR = "#e7e7e7";
export const UI_LABELS = {
  DRAG_HANDLE: "並替",
};

export const DRAG_HANDLE_STYLE = {
  BACKGROUND_COLOR: "#1890ff",
};
export const GROUP_TYPES = {
  DEFAULT: "default",
  PAID: "paid",
} as const;

export const SUB_GROUP_TYPES = {
  DATA_MASTER: "data-master",
  CREATIVE_APP: "creative-app",
  CORE_APP: "core-app",
} as const;

export const getFieldValues = <T extends Record<string, any>>(
  data: T[] | undefined,
  key: keyof T,
) => data?.filter((item) => !!item?.[key]).map((item) => item[key]) ?? [];

export const VIEW_MODE_OPTIONS = [
  { value: MODE.VIEW, label: "閲覧" },
  { value: MODE.EDIT, label: "編集" },
];

export const VIEW_MODE_OPTIONS_V2 = [
  { value: MODE.VIEW, label: "閲覧" },
  { value: MODE.EDIT, label: "レコード編集" },
];

export const OVERVIEW_DETAIL_MODE_OPTIONS = [
  { value: MODE.OVERVIEW, label: "概要" },
  { value: MODE.DETAIL, label: "詳細" },
];
export const VIEW_LIST_MODE_OPTIONS = [
  { value: MODE.VIEW, label: "閲覧", disabled: false },
  { value: MODE.EDIT, label: "レコード編集", disabled: false },
  { value: MODE.EDIT_LAYOUT, label: "レイアウト編集", disabled: false },
];

export * from "./categoryStatus.constant";
